import { useContext } from 'react';
import {
  RecommenderFiltersContext,
  RecommenderFiltersContextProps,
} from '../RecommenderFiltersProvider';

export const useRecommenderFilters = (): RecommenderFiltersContextProps => {
  return useContext(RecommenderFiltersContext);
};
